import { JustTcgVariant } from "@/api/types";
import { CardWithRelations, VariantWithRelations } from "@/hooks/useCards";
import { useQuery } from "@tanstack/react-query";
import { getVariantsByCard } from "@/api/variants";

export interface VariantCardItem {
  card: CardWithRelations;
  variantRecord?: VariantWithRelations;
  variantRaw: JustTcgVariant | null;
}

export interface UseVariantsCardsParams {
  page: number;
  limit: number;
  search?: string;
  setFilter?: string;
  cardsOverride?: CardWithRelations[];
}

export interface VariantsCardsResponse {
  data: VariantCardItem[];
  count: number; // number of variant items in the current page
  totalCards: number; // total cards count from server for pagination
}

/**
 * Hook that leverages useCards to fetch cards+variants, then flattens into a per-variant list.
 * Duplicates of the same card will appear if it has multiple variants.
 */
export function useVariantsCards(params: { cardId: number; enabled: boolean }) {
  const { cardId, enabled } = params;

  return useQuery({
    queryKey: ["card", "variants", cardId],
    queryFn: async () => {
      const data = await getVariantsByCard(cardId);

      return data.data;
    },
    enabled,
  });
}

export default useVariantsCards;
